module.exports = __webpack_public_path__ + "static/media/choose-payment-method.54521c43.svg";